<template>
  <div>
    <nav-bar />
    <section id="intro">
      <div class="profile-img-wrap">
        <img class="profile-img" src="crop-me.jpg" alt="profile-img"/>
      </div>
      <p class="hello-txt">Hello 👋🏽</p>
      <div class="wrapper dynamic-txt-box">
        <div class="static-txt">I'm</div>
        <ul class="dynamic-txts">
          <li><span>Madhavi Imashi Uyanahewa</span></li>
          <li><span>a Content Writer | Blogger</span></li>
          <li><span>a Software Developer</span></li>
          <li><span>a Graduate | BSc (hons) in SE</span></li>
        </ul>
      </div>
    </section>
    
    <section id="quote">
      <div class="panels">
      <div id="panel1" :class="componentClasses1" @click="openPanel1">
        <p>I</p>
        <p>Never</p>
        <p>Quit.</p>
      </div>
      
       <div id="panel2" :class="componentClasses2" @click="openPanel2">
        <p>Let me</p>
        <p>Be</p>
        <p>clear.</p>
      </div>
      
       <div id="panel3" :class="componentClasses3" @click="openPanel3" >
        <p></p>
        <p id="panel3Quote">Quick</p>
        <p></p>
      </div>
      
       <div id="panel4" :class="componentClasses4" @click="openPanel4" >
        <p>I Thrive</p>
        <p>To</p>
        <p>Success.</p>
      </div>
      
       <div id="panel5" :class="componentClasses5" @click="openPanel5" >
        <p>Better</p>
        <p>Judge</p>
        <p>Me Later</p>
      </div>
      </div>
    </section>
      
    <section id="learnings">
      <div class="technology-section-wrap">
        <b-row>
          <b-col sm="7" class="tech-description">
          <div>
            <div class="tech-desc-title">TECHNOLOGIES THAT I'M FAMILIAR WITH..</div>
            <p>I'm a passionate and self-driven software developer dedicated to crafting immersive digital experiences. With a strong software engineering background, I'm committed to transforming complex challenges into elegant solutions</p><br>
            <p>My proficiency includes object-oriented programming and hands-on experience in technologies like HTML, CSS, JavaScript, Java, Python, React, Vue, Node.js, SQL, NoSQL, RESTful web services, and Git. </p>
            <br>
            <div class="contact-list">
              <ul>
                <li><span class="contact-me-txt">CONNECT:</span></li>
                <li><a href="https://www.linkedin.com/in/madhaviuyanahewa/" target="_blank"><i class="fab fa-linkedin"></i></a></li>
                <li><a href="https://www.facebook.com/imashi.uh/" target=" _blank"><i class="fab fa-facebook"></i></a></li>
                <li><a href="https://github.com/MadhaviImashi" target=" _blank"><i class="fab fa-github"></i></a></li>
                <li><a href="https://medium.com/@madhaviuyanahewa" target=" _blank"><i class="fab fa-medium"></i></a></li>
                <li><a href="https://www.behance.net/madhaviuyanahe" target=" _blank"><i class="fab fa-behance"></i></a></li>
              </ul>
            </div>
            <br>
            <b-button class="blinking-button" variant="outline-secondary" @click="showCV">VIEW MY RESUME</b-button>
          </div>
          </b-col>

          <b-col sm="5" class="tech-icons-card-wrap">
            <b-card class="tech-icons-card border-0">
            <b-row class="tech-icons-row">
              <b-col>
                <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target=" _blank" title="JavaScript"><img src="https://github.com/get-icon/geticon/raw/master/icons/javascript.svg" alt="JavaScript" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://tc39.es/ecma262/" target=" _blank" title="ECMAScript 6"><img src="https://github.com/get-icon/geticon/raw/master/icons/es6.svg" alt="ECMAScript 6" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://vuejs.org/" target=" _blank" title="Vue.js"><img src="https://github.com/get-icon/geticon/raw/master/icons/vue.svg" alt="Vue.js" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://sass-lang.com/" target=" _blank" title="Sass"><img src="https://github.com/get-icon/geticon/raw/master/icons/sass.svg" alt="Sass" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://reactjs.org/" target=" _blank" title="React"><img src="https://github.com/get-icon/geticon/raw/master/icons/react.svg" alt="React" width="40px" height="40px"></a>
              </b-col>
            </b-row>
            <b-row class="tech-icons-row">
              <b-col> 
                <a href="https://ant.design/" target=" _blank" title="Ant Design"><img src="https://github.com/get-icon/geticon/raw/master/icons/ant-design.svg" alt="Ant Design" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://getbootstrap.com/" target=" _blank" title="Bootstrap"><img src="https://github.com/get-icon/geticon/raw/master/icons/bootstrap.svg" alt="Bootstrap" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://www.w3.org/TR/html5/" target=" _blank" title="HTML5"><img src="https://github.com/get-icon/geticon/raw/master/icons/html-5.svg" alt="HTML5" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://nodejs.org/" target=" _blank" title="Node.js"><img src="https://github.com/get-icon/geticon/raw/master/icons/nodejs-icon.svg" alt="Node.js" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://expressjs.com/" target=" _blank" title="C"><img src="https://github.com/get-icon/geticon/raw/master/icons/c.svg" alt="C" width="40px" height="40px"></a>
              </b-col>
            </b-row>
            <b-row class="tech-icons-row">
              <b-col>
                <a href="https://laravel.com/" target=" _blank" title="Laravel"><img src="https://github.com/get-icon/geticon/raw/master/icons/laravel.svg" alt="Laravel" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://www.java.com/" target=" _blank" title="Java"><img src="https://github.com/get-icon/geticon/raw/master/icons/java.svg" alt="Java" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://www.python.org/" target=" _blank" title="Python"><img src="https://github.com/get-icon/geticon/raw/master/icons/python.svg" alt="Python" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://eslint.org/" target=" _blank" title="ESLint"><img src="https://github.com/get-icon/geticon/raw/master/icons/eslint.svg" alt="ESLint" width="21px" height="21px"></a>
              </b-col>
              <b-col>
                <a href="https://prettier.io/" target=" _blank" title="Prettier"><img src="https://github.com/get-icon/geticon/raw/master/icons/prettier.svg" alt="Prettier" width="21px" height="21px"></a>
              </b-col>
            </b-row>
            <b-row class="tech-icons-row">
              <b-col>
                <a href="https://jestjs.io/" target=" _blank" title="Jest"><img src="https://github.com/get-icon/geticon/raw/master/icons/jest.svg" alt="Jest" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://code.visualstudio.com/" target=" _blank" title="Visual Studio Code"><img src="https://github.com/get-icon/geticon/raw/master/icons/visual-studio-code.svg" alt="Visual Studio Code" width="21px" height="21px"></a>
              </b-col>
              <b-col>
                <a href="https://www.mongodb.org/" target=" _blank" title="MongoDB"><img src="https://github.com/get-icon/geticon/raw/master/icons/mongodb-icon.svg" alt="MongoDB" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://dev.mysql.com/" target=" _blank" title="MySQL"><img src="https://github.com/get-icon/geticon/raw/master/icons/mysql.svg" alt="MySQL" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://git-scm.com/" target=" _blank" title="Git"><img src="https://github.com/get-icon/geticon/raw/master/icons/git-icon.svg" alt="Git" width="40px" height="40px"></a>
              </b-col>
            </b-row>
            <b-row class="tech-icons-row">
              <b-col>
                <b-tooltip target="npm-link" title="npm" triggers="hover"></b-tooltip>
                <a href="https://www.npmjs.com/" target=" _blank" title="npm"><img src="https://github.com/get-icon/geticon/raw/master/icons/npm.svg" alt="npm" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://material-ui.com/" target=" _blank" title="Material UI"><img src="https://github.com/get-icon/geticon/raw/master/icons/material-ui.svg" alt="Material UI" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://flutter.dev/" target=" _blank" title="Flutter"><img src="https://github.com/get-icon/geticon/raw/master/icons/flutter.svg" alt="Flutter" width="40px" height="40px"></a>
              </b-col>
              <b-col>
                <a href="https://material-ui.com/" target=" _blank" title="Postman"><img src="https://github.com/get-icon/geticon/raw/master/icons/postman.svg" alt="Postman" width="40px" height="40px"></a>
              </b-col>
            </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </section>

        <!-- ======= Portfolio Section ======= -->
        <section id="work" class="work-section work-section-container portfolio-mf sect-pt4 route">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title-box text-center">
              <h3 class="title-a">
                PROJECTS COMPLETED
              </h3>
              <div class="line-mf"></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="work-box">
              <a href="12.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="12.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="tech-box-container">
                      <span class="tech-box">ReactNative</span>
                      <span class="tech-box">Expo</span>
                      <span class="tech-box">Node</span>
                      <span class="tech-box">MongoDB</span>
                      <span class="tech-box">CSS</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/179924583/Space-exploration-app" target="blank">Mobile Design</a></span> / <span class="w-date">Tech Thriathlon</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="https://www.behance.net/gallery/179924583/Space-exploration-app"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="5.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="5.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Lorem impsum dolor</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">ReactNative</span>
                      <span class="tech-box">Expo</span>
                      <span class="tech-box">Python</span>
                      <span class="tech-box">Firebase</span>
                      <span class="tech-box">AWS</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/176137191/Expense-Prediction-based-on-users-calendar-events" target="blank">Mobile Design</a></span> / <span class="w-date">4th Year Research</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="https://madhaviimashi.github.io/wonga.github.io/" target="blank"> <span style="font-size: 11px;" class="bi bi-plus-circle">website</span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="3.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="3.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Loreda Cuno Nere</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">React</span>
                      <span class="tech-box">Express</span>
                      <span class="tech-box">Node.js</span>
                      <span class="tech-box">MongoDB</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/143060395/Login-SignUp-forms-for-Research-Project-Management-Tool" target="blank">Web Design</a></span> / <span class="w-date">Year 3 Semester 2</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="portfolio-details.html"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="4.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="4.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Mavrito Lana Dere</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">React</span>
                      <span class="tech-box">Koa.js</span>
                      <span class="tech-box">Node.js</span>
                      <span class="tech-box">MongoDB</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/145371465/Online-movie-reservation-system" target="blank">Web Design</a></span> / <span class="w-date">Year 3 Semester 2</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="portfolio-details.html"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="9.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="9.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Bindo Laro Cado</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Java</span>
                      <span class="tech-box">Volley</span>
                      <span class="tech-box">Express</span>
                      <span class="tech-box">Node.js</span>
                      <span class="tech-box">MongoDB</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/156257653/SL-Fuel-App" target="blank">Mobile Design</a></span> / <span class="w-date">Year 4 Semester 1</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="portfolio-details.html"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="2.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="2.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Studio Lena Mado</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">HTML5</span>
                      <span class="tech-box">CSS</span>
                      <span class="tech-box">Javascript</span>
                      <span class="tech-box">Bootstrap</span>
                      <span class="tech-box">PHP</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/125410597/Online-Meal-Cart" target="blank">Web Design</a></span> / <span class="w-date">Year 2 Semester 1</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="portfolio-details.html"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="10.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="10.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">PHP</span>
                      <span class="tech-box">Laravel</span>
                      <span class="tech-box">phpMyAdmim</span>
                      <span class="tech-box">MySQL</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/125410315/Online-Hotel-Management-System" target="blank">Web Design</a></span> / <span class="w-date">Year 2 Semester 2</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="portfolio-details.html"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="1.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="1.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Java</span>
                      <span class="tech-box">JSP</span>
                      <span class="tech-box">Servlet</span>
                      <span class="tech-box">CSS</span>
                      <span class="tech-box">MySQL</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/125410895/LoginRegistration-of-an-Event-management-system" target="blank">Web Design</a></span> / <span class="w-date">Year 2 Semester 1</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="portfolio-details.html"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="8.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="8.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Java</span>
                      <span class="tech-box">SQLite</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/125409683/BestPlan_For-a-healthy-simple-productive-lifestyle" target="blank">Web Design</a></span> / <span class="w-date">Year 2 Semester 2</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="portfolio-details.html"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="7.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="7.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Vue.js</span>
                      <span class="tech-box">Laravel</span>
                      <span class="tech-box">phpMyAdmin</span>
                      <span class="tech-box">MySQL</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://www.behance.net/gallery/126216469/Vaccination-Management-System-C19" target="blank">Web Design</a></span> / <span class="w-date">Year 3 Semester 1</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="portfolio-details.html"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="11.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="11.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">React</span>
                      <span class="tech-box">Express</span>
                      <span class="tech-box">Node.js</span>
                      <span class="tech-box">Firebase</span>
                      <span class="tech-box">Heroku</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://github.com/MadhaviImashi/LMS_frontend" target="blank">Project Link</a></span> / <span class="w-date">personal project</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="https://github.com/MadhaviImashi/LMS_frontend"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="work-box">
              <a href="6.png" data-gallery="portfolioGallery" class="portfolio-lightbox">
                <div class="work-img">
                  <img src="6.png" alt="" class="img-fluid">
                </div>
              </a>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <!-- <h2 class="w-title">Studio Big Bang</h2> -->
                    <div class="tech-box-container">
                      <span class="tech-box">Vue.js</span>
                      <span class="tech-box">CSS</span>
                      <span class="tech-box">Bootstrap</span>
                    </div>
                    <div class="w-more">
                      <span class="w-ctegory"><a style="text-decoration: none;" href="https://imashiuyanahewa.netlify.app" target="blank">Web Design</a></span> / <span class="w-date">personal project</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <a href="https://imashiuyanahewa.netlify.app"> <span class="bi bi-plus-circle"></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section><!-- End Portfolio Section -->

        <!-- ======= Blog Section ======= -->
    <section id="blog" class="blog-section-container blog-mf sect-pt4 route">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="title-box text-center">
              <h3 class="title-a">
                ✍️  CHECKOUT MY LATEST BLOG POSTS
              </h3>
              <!-- <p class="subtitle-a">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p> -->
              <div class="line-mf"></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="card card-blog">
              <div class="card-img">
                <a href="https://madhaviuyanahewa.medium.com/javascript-asynchronous-programming-5aad2041e50" target="blank"><img src="https://miro.medium.com/max/1400/1*YtYfgsFjc9K6U1-hpUYv8A.png" alt="" class="blog-img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Tech</h6>
                  </div>
                </div>
                <h3 class="card-title"><a class="blog-card-title-text" href="https://madhaviuyanahewa.medium.com/javascript-asynchronous-programming-5aad2041e50" target="blank">Javascript Asynchronous Programming </a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus. Praesent sapien massa, convallis
                  a pellentesque nec,
                  egestas non nisi.
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 5 min
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-blog">
              <div class="card-img">
                <a href="https://madhaviuyanahewa.medium.com/what-is-a-rest-api-340e40c4e760" target="blank"><img src="https://miro.medium.com/max/1300/1*Zc8f4cvCQk05jsSqm13jYw.png" alt="" class="blog-img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Tech</h6>
                  </div>
                </div>
                <h3 class="card-title"><a class="blog-card-title-text"  href="https://madhaviuyanahewa.medium.com/what-is-a-rest-api-340e40c4e760" target="blank">What is a REST API? </a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus. Praesent sapien massa, convallis
                  a pellentesque nec,
                  egestas non nisi.
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 6 min
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-blog">
              <div class="card-img">
                <a href="https://madhaviuyanahewa.medium.com/a-guide-on-how-to-generate-a-pdf-file-in-your-laravel-8-application-82d6225c8c7f" target="blank"><img src="https://miro.medium.com/max/700/1*WEChqyGkX0tujd-de2tg6A.png" alt="" class="blog-img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Tech</h6>
                  </div>
                </div>
                <h3 class="card-title"><a class="blog-card-title-text"  href="https://madhaviuyanahewa.medium.com/a-guide-on-how-to-generate-a-pdf-file-in-your-laravel-8-application-82d6225c8c7f" target="blank">A guide to generate a PDF file in your Laravel 8 app</a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus. Praesent sapien massa, convallis
                  a pellentesque nec,
                  egestas non nisi.
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 4 min
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-blog">
              <div class="card-img">
                <a href="https://madhaviuyanahewa.medium.com/getting-started-with-mongodb-bb844aa8fb6f" target="blank"><img src="https://miro.medium.com/max/650/1*qp2eL9tH7Hy0_pcB4IWk4Q.png" alt="" class="blog-img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Tech</h6>
                  </div>
                </div>
                <h3 class="card-title"><a class="blog-card-title-text"  href="https://madhaviuyanahewa.medium.com/getting-started-with-mongodb-bb844aa8fb6f" target="blank">Getting started with MongoDB</a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus. Praesent sapien massa, convallis
                  a pellentesque nec,
                  egestas non nisi.
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 6 min
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-blog">
              <div class="card-img">
                <a href="https://madhaviuyanahewa.medium.com/introduction-to-koa-js-6e0b483a2bf3" target="blank"><img src="https://miro.medium.com/max/650/1*bGouMpCfFdp6W1SBj6DMCg.png" alt="" class="blog-img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Tech</h6>
                  </div>
                </div>
                <h3 class="card-title"><a class="blog-card-title-text"  href="https://madhaviuyanahewa.medium.com/introduction-to-koa-js-6e0b483a2bf3" target="blank">Introduction to Koa JS</a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus. Praesent sapien massa, convallis
                  a pellentesque nec,
                  egestas non nisi.
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 3 min
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-4">
            <div class="card card-blog">
              <div class="card-img">
                <a href="blog-single.html"><img src="../assets/img/post-3.jpg" alt="" class="img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Life</h6>
                  </div>
                </div>
                <h3 class="card-title"><a href="blog-single.html">No matter what life throws at you. how you respond and what you make out of it is all up to you.</a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus.
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 10 min
                </div>
              </div>
            </div>
          </div> -->
          <div class="col-md-3">
            <div class="card card-blog">
              <div class="card-img">
                <a href="https://madhaviuyanahewa.medium.com/what-are-nosql-databases-and-when-to-use-them-c1b43f3c2fb4" target="blank"><img src="https://miro.medium.com/max/650/1*RjheBOMaULRIMw5hTWXR7w.png" alt="" class="blog-img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Tech</h6>
                  </div>
                </div>
                <h3 class="card-title"><a class="blog-card-title-text"  href="https://madhaviuyanahewa.medium.com/what-are-nosql-databases-and-when-to-use-them-c1b43f3c2fb4" target="blank">What are NoSQL databases and when to use them? </a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus. Praesent sapien massa.
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 3 min
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-blog">
              <div class="card-img">
                <a href="https://madhaviuyanahewa.medium.com/ever-wonder-what-the-difference-between-the-main-branch-and-the-master-branch-of-git-cb9a2bbab8bf" target="blank"><img src="https://miro.medium.com/v2/resize:fit:1000/format:webp/1*fxGcteIDaqq-0YilsX5VlA.png" alt="" class="blog-img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Tech</h6>
                  </div>
                </div>
                <h3 class="card-title"><a class="blog-card-title-text"  href="https://madhaviuyanahewa.medium.com/ever-wonder-what-the-difference-between-the-main-branch-and-the-master-branch-of-git-cb9a2bbab8bf" target="blank">Have you ever wondered whether there’s a difference between the “main” branch and the “master” branch of repositories in GitHub?</a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus. 
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 6 min
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-4">
            <div class="card card-blog">
              <div class="card-img">
                <a href="blog-single.html"><img src="../assets/img/post-2.jpg" alt="" class="img-fluid"></a>
              </div>
              <div class="card-body blog-card-title">
                <div class="card-category-box">
                  <div class="card-category">
                    <h6 class="category">Life</h6>
                  </div>
                </div>
                <h3 class="card-title"><a href="blog-single.html">Set your mindset to stay more productive during the day.</a></h3>
                <p class="card-description">
                  Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus. Praesent sapien massa, convallis
                  a pellentesque nec,
                  egestas non nisi.
                </p>
              </div>
              <div class="card-footer">
                <div class="post-author">
                  <a href="#">
                    <img src="mee.jpeg" alt="" class="avatar rounded-circle">
                    <span class="author">Imashi Uyanahewa</span>
                  </a>
                </div>
                <div class="post-date">
                  <span class="bi bi-clock"></span> 10 min
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section><!-- End Blog Section -->

    <section id="contact">
       <!-- <h3>Connect with me</h3> -->
      <div class="contact-list2">
        <ul>
          <!-- <li><span class="contact-me-txt">CONTACT ME VIA  ~ </span></li> -->
          <li><a href="https://www.linkedin.com/in/madhaviuyanahewa/" target="_blank"><i class="fab fa-linkedin"></i></a></li>
          <li><a href="https://www.facebook.com/imashi.uh/" target=" _blank"><i class="fab fa-facebook"></i></a></li>
          <li><a href="https://github.com/MadhaviImashi" target=" _blank"><i class="fab fa-github"></i></a></li>
          <li><a href="https://medium.com/@madhaviuyanahewa" target=" _blank"><i class="fab fa-medium"></i></a></li>
          <li><a href="https://www.behance.net/madhaviuyanahe" target=" _blank"><i class="fab fa-behance"></i></a></li>
        </ul>
      </div>
      <!-- loading spinner -->
        <div class="page-loader" v-if="!isloaded">
          <div class="cube cube1">M</div>
          <div class="cube cube2">I</div>
          <div class="cube cube3">R</div>
          <div class="cube cube4">U</div>
        </div> 

    </section>
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
// import Footer from "../components/Footer.vue";

export default {
  name: "Home",
    mounted() {
      // document.onreadystatechange = () => {
      //   if (document.readyState == "complete") {
          setTimeout(() => {
            this.isloaded = true;
          }, 200)
      //     this.isloaded = true;
      //   }
      // }
    //   document.addEventListener("DOMContentLoaded", () => {
    //   this.isLoaded = true;
    //     console.log('lllll', this.isLoaded);
    // });
    },
  data: () => ({
    isloaded: false,
    panelOpen1: false,
    panelOpen2: false,
    panelOpen3: false,
    panelOpen4: false,
    panelOpen5: false,
  }),
  methods: {
    showCV() {
      this.$router.push('/cv')
    },
    openPanel1() {
      if (this.panelOpen1) {
        this.panelOpen1 = false;
      } else {
        this.panelOpen1 = true;  
      }
    },
    openPanel2() {
      if (this.panelOpen2) {
        this.panelOpen2 = false;
      } else {
        this.panelOpen2 = true;  
      }
    },
    openPanel3() {
      if (this.panelOpen3) {
        this.panelOpen3 = false;
      } else {
        this.panelOpen3 = true;  
      }
    },
    openPanel4() {
      if (this.panelOpen4) {
        this.panelOpen4 = false;
      } else {
        this.panelOpen4 = true;  
      }
    },
    openPanel5() {
      if (this.panelOpen5) {
        this.panelOpen5 = false;
      } else {
        this.panelOpen5 = true;  
      }
    }
  },
  computed: {
    componentClasses1: function () {
      console.log('ll', this.panelOpen1);
      return {
        "panel": true,
        "open": this.panelOpen1,
        "open-active": this.panelOpen1
      }
    },
    componentClasses2: function () {
      console.log('ll', this.panelOpen2);
      return {
        "panel": true,
        "open": this.panelOpen2,
        "open-active": this.panelOpen2
      }
    },
    componentClasses3: function () {
      console.log('ll', this.panelOpen3);
      return {
        "panel": true,
        "open": this.panelOpen3,
        "open-active": this.panelOpen3
      }
    },
    componentClasses4: function () {
      console.log('ll', this.panelOpen4);
      return {
        "panel": true,
        "open": this.panelOpen4,
        "open-active": this.panelOpen4
      }
    },
    componentClasses5: function () {
      console.log('ll', this.panelOpen5);
      return {
        "panel": true,
        "open": this.panelOpen5,
        "open-active": this.panelOpen5
      }
    }
  },
  components: {
    NavBar,
  },
};
</script>

<style scoped>
html {
  box-sizing: border-box;
  background: #ffc600;
  font-size: 20px;
  font-weight: 200;
}

body { margin: 0; }
                                           /* styles of Intro section */
#intro {
  background-color: black;
  padding-top: 220px;
/*   background-image: url(https://images.unsplash.com/photo-1523693777456-fb08941957cf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80);
  background-size: no-repeat;
  background-size: cover; */
  width: 100%;
  height: 580px;
  border-bottom: 5px solid #80817c;
}
.profile-img-wrap {
  text-align: center;
  padding-bottom: 40px;
}
.profile-img {
  width: 200px;
  height: 200px;
  border-radius: 50%;
}
                                          /* styles of Technologies section */
#learnings {
  background-color: black;
  padding-top: 20px;
  width: 100%;
  color: white;
}
                                          /* styles of Blogs section */
#blogs {
  background-color: #111111;
  padding-top: 20px;
  width: 100%;
  color: white;
}
.hand-icon {
  font-size: 20px;
}
.blogs-section-wrap {
  padding: 70px 30px 30px 30px;
}
.blog-section-title {
  /* text-align: center; */
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #80817c;
}
.blog{
  display: flex; /*this will display the 2 sections in this class next to each other*/
  flex-wrap: wrap; /* then it will go to the next line, when it doesn't have space*/
  max-width: 800px;
  margin: 20px 10px; /* this will make them align to center*/
  justify-content: center; /*videos came to the center after this*/
  background-color: black;
  padding: 20px;
  flex-direction: column;
  align-items: center;
  box-shadow: rgb(255 255 255 / 11%) 0px 48px 100px 0px;
}
.blog-img {
  border-radius: 2%;
}
.blog-caption {
  font-size: 12px;
  font-weight: 400;
}
.social-ul a{
  font-size: 30px;
  padding: 40px;
}

#connect {
  background-color: black;
}

*, *:before, *:after {
  box-sizing: inherit;
}
                                          /* styles of panels in Quotes section */
.panels {
  overflow: hidden;
  height: 680px;
  display: flex;
}

@media screen and (max-width: 600px) {
  #panel1 {
    display: none; /* Hide all panels by default on smaller screens */
  }
  #panel2 {
    display: none; /* Hide all panels by default on smaller screens */
  }
  #panel4 {
    display: none; /* Hide all panels by default on smaller screens */
  }
  #panel5 {
    display: none; /* Hide all panels by default on smaller screens */
  }
  #panel3Quote {
    display: none;
  }
  .panels {
    height: 500px;
  }
}

.panel {
  backface-visibility: purple;
  color: #E6E6E6;
/*   opacity: 0.95; */
  text-align: center;
  align-items: center;
  transition: 
    font-size 0.7s cubic-bezier(0.02,0.57,1,0.43),
    flex 0.7s cubic-bezier(0.02,0.57,1,0.43),
    background 0.2s;
  font-size: 20px;
  background-size:cover;
  background-position:center;
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  cursor:nesw-resize;
}
/* .panel cursor {
  width: 20px;
  height: 20px;
  border: 1px solid white;
  border-radius: 50%;
  position: absolute;
  transition-duration: 200ms;
  transition-timing-function: ease-out;
  animation: cursorAnim .5s infinite alternate;
  pointer-events: none;
} */
#panel1 {background-image:url("../../public/imgLeft.png")}
#panel2 {background-image:url("../../public/imgRepeated.jpg")}
#panel3 {background-image:url("../../public/imgMIddle.png")}
#panel4 {background-image:url("../../public/imgRepeated.jpg")}
#panel5 {background-image:url("../../public/imgRight.png")}

/*flex items*/
.panel > * {
  margin: 0;
  width: 100%;
  transition: transform 0.5s;
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.panel > *:first-child { transform: translateY(-100%); } /*hide upward*/
.panel.open-active > *:first-child { transform: translateY(0); }
.panel > *:last-child { transform: translateY(100%); }/*hide downwards*/
.panel.open-active > *:last-child { transform: translateY(0); }

.panel p {
  text-transform: uppercase;
/* font-family: 'Amatic SC', cursive; */
  font-size: 40px;
  font-weight: 500;
}
.panel p:nth-child(2) {
  font-size: 30px;
  font-weight: 500;
  color: white;
}
.panel.open {
  flex: 5;
  font-size: 2em;
  color: #8e8f8c;
  cursor: pointer;
}
.panel.open p:nth-child(2) {
  font-size: 30px;
  font-weight: 400;
  color: white;
}
                                          /* styles of dynamic text in the Intro section */
.hello-txt {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
  font-size: 15px;
}
.dynamic-txt-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
}
.wrapper{
  display: flex;
  margin-left: 20px;
}
.wrapper .static-txt{
  color: #fff;
  font-size: 28px;
  font-weight: 400;
}
.wrapper .dynamic-txts{
  height: 90px;
  line-height: 90px;
  overflow: hidden;
}
.dynamic-txts li{
  list-style: none;
  color: #80817c;
  font-size: 30px;
  font-weight: 600;
  position: relative;
  top: 0;
  animation: slide 16s steps(4) infinite;
}
@keyframes slide {
  100%{
    top: -360px;
  }
}
.dynamic-txts li span{
  position: relative;
  margin: 5px 0;
  line-height: 90px;
}
.dynamic-txts li span::after{
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: black;
  border-left: 2px solid #80817c;
  animation: typing 4s steps(10) infinite;
}
@keyframes typing {
  40%, 60%{
    left: calc(100% + 30px);
  }
  100%{
    left: 0;
  }
}
                                            /* styles of Technologies section */
.technology-section-wrap {
  padding: 90px 140px;
}
.tech-description {
  padding: 10px 20px 10px 10px;
  border-bottom: 0.5px solid #80817c;
}
.tech-desc-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 15px;
}
.tech-icon-card-wrap {
  background-color: #111;
}
.tech-icon-card {
  background-color: #80817c;
  /* border-radius: 10%; */
}
.tech-icons-row {
  margin-bottom: 40px;
}

                                            /* styles of footer section */
#contact {
  /* border-top: 2px solid #80817c; */
  background: black;
  align-content: center;
  justify-content: center;
  color: white;
  background-color: black;
  border-top: 2px solid #80817c;
}
.contact-list {
  display: flex;
}
.contact-list2 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.contact-list ul, .contact-list2 ul{
  display: flex;
  margin: 0; /*this will remove the empty spaces/margins coming around */
  padding: 0;
  margin-bottom: 20px;
  padding-bottom: 20px;
  margin-top: 20px;
  justify-content: center;
  list-style-type: none;
  font-size: 20px;
}
.contact-list ul li a{
  color:#80817c;
  padding: 20px;
  text-decoration: none;
}
.contact-list2 ul li a {
  color: #80817c;
  padding: 20px;
  text-decoration: none;
}
.miru {
  color: black;
  background-color: #80817c;
  padding-top: 0px;
  margin-top: 0px;
}
.contact-me-txt {
  font-size: 13px;
  font-weight: 600;
  margin-right: 10px;
  color: #80817c;
}

/* ovewrite some styles ..*/
ul, p {
  margin-bottom: 0 !important;
}
.card-body {
  background-color: #000;
  padding: 20px;
}

@media only screen and (max-width: 1200px) {
.technology-section-wrap {
  padding: 15px 25px;
}
}

@media only screen and (max-width: 1200px) {
.contact-list ul li a{
  padding: 10px;
}
}

                                      /* loading animation spinner */
/* $colors: #8CC271, #69BEEB, #F5AA39, #E9643B; */
  .page-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: black;
    z-index: 999;
  }
  .cube{
    width: 40px;
    height: 40px;
    color: black;
    font-weight: 600;
    text-align: center;
    font-size: 20px;
    padding-top: 5px;
    margin-right: 10px;
    border-radius: 50%;
    background-color: #555;
  }
  .cube1 {
    position: relative;
    animation: moveToLeft 2s infinite;
  }
    /* .cube2 {
    position: relative;
    animation: moveToLeftLittle 2s infinite;
  }
  .cube3 {
    position: relative;
    animation: moveToRightLittle 2s infinite;
  } */
  .cube4 {
    position: relative;
    animation: moveToRight 2s infinite;
  }

@keyframes moveToRight {
  from {left: 0px;}
  to {left: 10px;}
}
@keyframes moveToLeft {
  from {right: 0px;}
  to {right: 10px;}
}
/* @keyframes moveToRightLittle {
  from {left: 0px;}
  to {left: 5px;}
}
@keyframes moveToLeftLittle {
  from {right: 0px;}
  to {right: 5px;}
} */

/*--------------------------------------------------------------
# Portfolio
--------------------------------------------------------------*/
.work-box {
  margin-bottom: 3rem;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: #fff;
}

.work-box:hover img {
  transform: scale(1.3);
}

.work-img {
  display: block;
  overflow: hidden;
}

.work-img img {
  transition: all 1s;
}

.work-content {
  background: black;
  padding: 1rem 3% 1rem 4%;
}

.work-content .w-more {
  padding-top: 5px;
  color: #4e4e4e;
  font-size: 0.8rem;
}

.w-date {
  color: darkgray;
}

.work-content .w-more .w-ctegory {
  color: #0078ff;
}

.work-content .w-like {
  font-size: 2.5rem;
  color: #0078ff;
  float: right;
}

.work-content .w-like a {
  color: #0078ff;
}

.work-content .w-like .num-like {
  font-size: 0.7rem;
}

.w-title {
  font-size: 1.2rem;
}

/*--------------------------------------------------------------
# Portfolio Details
--------------------------------------------------------------*/
.portfolio-details {
  padding-top: 40px;
}

.portfolio-details .portfolio-details-slider img {
  width: 100%;
}

.portfolio-details .portfolio-details-slider .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #fff;
  opacity: 1;
  border: 1px solid #0078ff;
}

.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #0078ff;
}

.portfolio-details .portfolio-info {
  padding: 30px;
  box-shadow: 0px 0 30px rgba(78, 78, 78, 0.08);
}

.portfolio-details .portfolio-info h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.portfolio-details .portfolio-info ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}

.portfolio-details .portfolio-info ul li+li {
  margin-top: 10px;
}

.portfolio-details .portfolio-description {
  padding-top: 30px;
}

.portfolio-details .portfolio-description h2 {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 20px;
}

.portfolio-details .portfolio-description p {
  padding: 0;
}

/*--------------------------------------------------------------
# Blog
--------------------------------------------------------------*/
/* @media (max-width: 767px) { */
  .card-blog {
    margin-bottom: 3rem;
    min-height: 370px;
    /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    /* text-align: justify; */
  }
/* } */

.card-blog .card-body {
  position: relative;
  background: #000;
}

.card-blog .card-category-box {
  position: absolute;
  text-align: center;
  top: -16px;
  left: 15px;
  right: 15px;
  line-height: 25px;
  overflow: hidden;
}

.card-blog .card-category {
  display: inline-block;
  color: black;
  padding: 0 15px 5px;
  overflow: hidden;
  background-color: white;
  border: 1px solid black;
  border-radius: 10%;
  border-radius: 4px;
}

.card-blog .card-category .category {
  /* color: #fff; */
  display: inline-block;
  /* text-transform: uppercase; */
  font-size: 0.7rem;
  letter-spacing: 0.1px;
  margin-bottom: 0;
}

.card-blog .card-title {
  font-size: 14px;
  margin-top: 0.6rem;
}

.card-blog .card-description {
  font-size: 12px;
  color: #a1a1a1;
  text-align: justify;
}

.card-blog .post-author {
  display: inline-block;
  font-size: 12px;
}

.card-blog .post-date {
  color: #a1a1a1;
  display: inline-block;
  float: right;
}

.avatar {
  width: 25px;
  height: 25px;
  margin-right: 4px;
  overflow: hidden;
}

.blog-card-title {
  background-color: white;
  text-decoration: none;
}

.blog-section-container {
  background: #000000;
  /* background-image: url(../../public/flowery-bg.png);
    background-repeat: no-repeat;
    background-size: cover; */
  padding: 30px 140px 50px 140px;
}

.card-footer {
  background-color: #363636;
  font-size: 12px;
}
.work-section {
  background: #000000;
  background-image: url(../../public/bb.png);
    /* background-repeat: no-repeat; */
    background-size: contain;
    opacity: 0.9;
}

.work-section-container {
  padding: 30px 140px 50px 140px;
}

.tech-box-container {
  display: flex;
  flex-direction: inherit;
}
.tech-box {
    padding: 5px 10px;
    margin-right: 5px;
    font-size: 11px;
    color: white;
    border-radius: 10%;
    background: #80817c;
}

.title-a {
  font-size: 14px;
  color: gray;
  font-weight: bold;
  padding-bottom: 20px;
}

.blog-img-fluid {
  width: 100%;
  height: 150px;
}

.blog-card-title-text {
  color: #d4d4d4;
  text-decoration: none;
}

@media (min-width: 1400px) {
.container-xxl, .container-xl, .container-lg, .container-md, .container {
    max-width: 1920px;
}
}

@media (min-width: 300px) and (max-width: 992px) {
.contact-list {
  flex-wrap: wrap;
}
.contact-list2 {
  flex-wrap: wrap;
}
.tech-box-container {
  flex-wrap: wrap;
}
.tech-box {
  margin-bottom: 5px;
}
.blog-section-container{
  padding: 20px !important;
}
.work-section-container {
  padding: 20px !important;
}
}


/* Define the blinking animation */
@keyframes blink {
  0% {
    background-color: transparent; /* Initial background color */
  }
  50% {
    background-color: #6c757d; /* Color to blink */
    color: white;
  }
  100% {
    background-color: transparent; /* Back to the initial background color */
  }
}

/* Apply the animation to the button */
.blinking-button {
  animation: blink 3s infinite; 
  margin-bottom: 20px;
}


</style>